'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _selectionConstants = require('../../common/elements/selectionConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initial state
// Lib
var initialState = Immutable.Map({
    userId: null
});

// Constants


var updateSelectedElement = function updateSelectedElement(state, action) {
    return state.set('userId', action.user._id);
};
var removeSelectedElement = function removeSelectedElement(state, action) {
    return state.set('userId', null);
};

// Reducer

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _selectionConstants.ELEMENTS_SELECTED:
            return updateSelectedElement(state, action);
        case _selectionConstants.ELEMENTS_DESELECTED:
            return removeSelectedElement(state, action);
        case _selectionConstants.ELEMENTS_DESELECT_ALL:
            return initialState;
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/remoteActivity/selectedElementReducer.js
// module id = 2045
// module chunks = 0